import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TripMetadata } from '../_models/driver-data';

@Injectable({
  providedIn: 'root'
})
export class DriverSignerService {

  private driverSignerData: BehaviorSubject<TripMetadata>;
  public driverSignerData$: Observable<TripMetadata>;
  public documentsLocation: string;
  public documentsYard: string;

  constructor(
    private http: HttpClient
  ) { }

  public getTripData(encGuid: string){
    const options = {
      params: new HttpParams().set('isAnon', "true")
    };
    var url = `${environment.apiUrl}/api/driversign/tripdata/${encGuid}`;
    return this.http.get<any>(url, options);
  }

  public async getDriverStamp() {
    return new Promise<string>((resolve, reject) => {
    let result = "";
    const imagePath = `assets/img/driver-stamps/stamp-${this.documentsLocation}-${this.documentsYard}.PNG`
    
    this.http.get(imagePath, {responseType: 'arraybuffer'})
    .subscribe((data: ArrayBuffer) => {
      const base64Image = this.arrayBufferToBase64(data);
      result = `data:image/png;base64,${base64Image}`;
      resolve(result);
    },
    error => {
      result =  error;
      reject(result);
    });

    return result;
    })
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    const binary = String.fromCharCode(...new Uint8Array(buffer));
    return btoa(binary);
  }
}
